import { render, staticRenderFns } from "./Supermarket.vue?vue&type=template&id=530ac147&scoped=true&"
import script from "./Supermarket.vue?vue&type=script&lang=js&"
export * from "./Supermarket.vue?vue&type=script&lang=js&"
import style0 from "./Supermarket.vue?vue&type=style&index=0&id=530ac147&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530ac147",
  null
  
)

export default component.exports